export default {
  "command.category": "Terminal",
  "command.toggle": "Toggle terminal",
  "command.new": "New terminal",
  "command.new.description": "Create a new terminal tab",
  loading: "Loading terminal…",
  "title.numbered": "Terminal {{number}}",
  close: "Close terminal",
  "connectionLost.title": "Connection Lost",
  "connectionLost.abnormalClose": "WebSocket closed abnormally: {{code}}",
  "connectionLost.description": "The terminal connection was interrupted. This can happen when the server restarts.",
  "tab.title": "Terminal",
}
